export enum LocalStorageKeys {
    BackgroundColor = 'backgroundColor',
    DebugBot = 'debugBot',
    Theme = 'theme',
    UnitTextSize = 'unitTextSize',
    Volume = 'volume',
    CountryHoverEffect = 'enableCountryHoverEffect',
};
